module.exports = __webpack_public_path__ + "static/img/image-shoes.585b7637.jpg";